// layouts
import { Authenticated } from '../../layouts/Authenticated/Authenticated';

// mui
import { Grid } from '@mui/material';

// cards
import { Contracts } from '../../ui/Contracts/Contracts';

export const PageContracts = () => {
	return (
		<Authenticated>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Contracts />
				</Grid>
			</Grid>
		</Authenticated>
	);
};
